import { render, staticRenderFns } from "./RejectedApplicationList.vue?vue&type=template&id=c53fa178&lang=html&"
import script from "./RejectedApplicationList.vue?vue&type=script&lang=js&"
export * from "./RejectedApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./RejectedApplicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports